const viewsOnTheNews = (state = null, action) => {
  const { payload, type } = action;
  let idsList = [];

  switch (type) {
    case 'INITIAL_DATA':
      return state?.length ? [...state] : [];

    case 'ADD_VIEWS_ON_THE_NEWS_DATA':
      return [...payload];

    case 'APPEND_VIEWS_ON_THE_NEWS':
      idsList = payload.map((x) => x?._id);
      return [...state.filter((x) => !idsList.includes(x._id)), ...payload];

    case 'UPDATE_VIEWS_ON_THE_NEWS':
      return state.map((view) => {
        if (view._id !== payload._id) return view;

        return {
          ...view,
          ...payload
        };
      });

    case 'INC_VIEWS_ON_THE_NEWS_COMMENT_COUNT':
      return state.map((view) => {
        if (view._id !== payload.postId) return view;

        return {
          ...view,
          commentsCount: view.commentsCount + 1
        };
      });

    default:
      return state;
  }
};

export default viewsOnTheNews;
